/* eslint-disable @typescript-eslint/no-invalid-void-type */
import {
  type CreditBalanceResponse,
  type CreditPackageResponse,
  type StartCheckoutSessionResponse,
  type StartTopupCheckoutRequest,
} from '../../types'
import api from '../api'

const creditsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    creditBalance: builder.query<CreditBalanceResponse, void>({
      query: () => ({
        url: 'api/credits/balance',
        method: 'GET',
      }),
      providesTags: ['Credits'],
    }),
    creditPackages: builder.query<CreditPackageResponse[], void>({
      query: () => ({
        url: 'api/credits/packages',
        method: 'GET',
      }),
    }),
    topupCheckout: builder.mutation<
      StartCheckoutSessionResponse,
      StartTopupCheckoutRequest & { redirectDomain?: string }
    >({
      query: (body) => ({
        url: 'api/credits/topup/start-checkout',
        method: 'POST',
        body,
      }),
    }),
  }),
})

export const { useCreditBalanceQuery, useCreditPackagesQuery, useTopupCheckoutMutation } =
  creditsApi

export default creditsApi
